<template>
  <div>
    <el-col :span="19">
      <div class="tag-div"
           style="position: relative">
        <div class="tag-content">
          <div class="tag-input"
               @click="overLabels()"
               @blur="outLabels($event)">
            <div class="checked-tag"
                 v-for="(item,index) in inputList"
                 :key="index">
              {{item.labelName}}
              <span style="font-size: 12px"
                    disabled
                    v-if="closeLabel"
                    @click="deleteTag(item)"><svg aria-hidden="true"
                                                  class="icon-svg">
                  <use xlink:href="#icon-close">
                  </use>
                </svg></span>
            </div>
          </div>
        </div>
        <div class="tag-option"
             v-show="closeShow">
          <div class="option-tree"
               disabled>
            <el-tree :expand-on-click-node="false"
                     :data="parentDealeList"
                     :props="defaultProps"
                     @node-click="handleNodeClick"></el-tree>
          </div>
          <div class="option-content">
            <div class="each-tag"
                 :class="item.checked ? 'checked' : ''"
                 v-for="(item,index) in checkList"
                 :key="index"
                 @click="clickTag(item)">
              {{item.labelName}}
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </el-col>
  </div>
</template>
<script>
  export default {
    components: {},
    data () {
      let _this = this
      return {
        brandCodes: '',
        code: [],
        data: [],
        defaultProps: {
          id: 'labelId',
          children: 'children',
          label: 'labelName'
        },
        checkList: [],
        wholeList: _this.checkedData,
        inputList: _this.wholeList,
        currentBrandCodeArr: [],
        parentDealeList: [],
        brandCodeArr: [],
        overLabel: false,
        closeLabel: true
      }
    },
    watch: {
      brandCode(newValue, oldValue) {
        this.code = newValue
        this.checkList = []
        //this.getDealer(this.code)
        this.getDealer()
      },
      checkedList(newValue) {
        debugger
        console.log(newValue,"here")
        this.inputList = newValue
        // this.initData1(this.parentDealeList, newValue, this.inputList)
      },
      // checkedList:{
      //   handler(newValue, oldValue) {
      //     this.inputList = newValue
      //     if(!newValue && !oldValue) return
      //     if(newValue.length<oldValue.length){
      //       this.checkedList=oldValue
      //     }
      //
      //   },
      //   immediate: true,
      //   deep:true
      // },
      code(newValue, oldValue) {
        if (newValue == null || newValue === '') {
          this.parentDealeList = []
        }
      }
    },
    mounted () {
      console.log('--------------------------------------------- mounted ---------------------------------------------------------------')
      this.getDealer()
      // this.getBussinessDefine()
      let data = this.parentDealeList
      if (data.length !== 0) {
        this.initData(data)
      }

    },
    props: {
      checkedData: Array,
      checkedList: Array,
      brandCode: Array,
      bussinessTypeId: Array,
      overLabelShow: Boolean,
      closeShow: Boolean
    },
    activated () {
      console.log('--------------------------------------------- activated ---------------------------------------------------------------')
      this.initData()
      console.log("here")
      this.checkList= []
    },
    methods: {
      changeTag () {
        console.warn(this.inputList)
        this.$emit('changeCheckedList', this.inputList)
      },
      overLabels () {
        this.overLabel = this.overLabelShow
      },
      outLabels (event) {
        event.stopPropagation()
        this.overLabel = false
      },
      // 取业务类型
      // getBussinessDefine () {
      //   this.$request.get('/sys/commbussinessdefine/', {}
      //   ).then((res, total, code, data) => {
      //     this.brandCodeArr = data.result
      //   }).catch(() => { })
      // },
      // handleNodeClick (data, node, templateNode) {
      //   this.$emit('getBussinessType', data.bussinessTypeId)
      //   this.checkList = []
      //   this.inputList = []
      //   this.changeTag()
      //   if (data.bussinessTypeId !== '' && data.bussinessTypeId) {
      //     this.getDealer(data.bussinessTypeId)
      //   } else {
      //     this.parentDealeList = []
      //   }
      // },
      // 取树
      getDealer (val) {
        if(this.bussinessTypeId.length > 0){
          console.info('this.bussinessTypeId-------------->', this.bussinessTypeId)
          this.$request.post('/sys/external/queryLabelsByBusinessTypeIds',this.bussinessTypeId

          ).then((res, total, code, data) => {
            if (data.data !== null) {
              let map = new Map()
              data.data.forEach(function (item) {
                map.set(item.labelId,item)
              })
              if(this.checkedList){
                this.wholeList = []
                this.wholeList = this.checkedList
                for (let i = 0; i < this.checkedList.length; i++){
                  let item = this.checkedList[i]
                  if(!map.has(item.labelId)){
                    this.checkedList.splice(i,1);
                    i--
                  }
                }
              }

              this.parentDealeList = this.treeDataTranslateForTag(data.data, 'labelId', 'parentLabelId')
            }else {
              this.parentDealeList = data.data
            }
            let parentDealeList = this.parentDealeList
            if (parentDealeList.length !== 0) {
              this.initData(parentDealeList)
            }
            this.$emit('fatherMethod')
          })
        }else{
          this.parentDealeList = []
        }

      },
      treeDataTranslateForTag (data, id = 'id', pid = 'pid') {
        var res = []
        var temp = {}
        // 判断空值时的返回
        if (data === undefined) {
          return res
        }
        for (var i = 0; i < data.length; i++) {
          temp[data[i][id]] = data[i]
        }
        for (var k = 0; k < data.length; k++) {
          if (!temp[data[k][pid]] || data[k][id] === data[k][pid]) {
            res.push(data[k])
            continue
          }
          if (!temp[data[k][pid]]['children']) {
            temp[data[k][pid]]['children'] = []
          }
          if (!temp[data[k][pid]]['tag']) {
            temp[data[k][pid]]['tag'] = []
          }
          if (data[k]['labelFlag'] === '20') {
            temp[data[k][pid]]['children'].push(data[k])
          } else if (data[k]['labelFlag'] === '10') {
            temp[data[k][pid]]['tag'].push(data[k])
          }

          data[k]['_level'] = (temp[data[k][pid]]._level || 0) + 1
        }
        return res
      },
      // 初始化数据加入是否选中，默认false  递归调用
      initData (data) {
        this.closeLabel = this.closeShow
        for (let item in data) {
          if (data[item].tag && data[item].tag.length > 0) {
            let tag = data[item].tag
            for (let index in tag) {
              tag[index]['checked'] = false
            }
            if (data[item].children && data[item].children.length > 0) {
              this.initData(data[item].children)
            }
          }
        }
        console.log(this.inputList)
      },
      // 初始化数据加入是否选中，默认false  递归调用
      initData1 (data, nvlValue, list) {
        debugger
        list = []
        this.closeLabel = this.closeShow
        for (let item in data) {
          if (data[item].tag && data[item].tag.length > 0) {
            let tag = data[item].tag
            for (let index in tag) {
              for (let value in nvlValue) {
                if (value.labelId === tag[index]['labelId']) {
                  list.push(value)
                }
              }
            }
            if (data[item].children && data[item].children.length > 0) {
              this.initData(data[item].children, nvlValue, list)
            }
          }
        }
        console.log(this.inputList)
      },
      // 点击树节点，把tag注入
      handleNodeClick (data) {
        if (data.tag && data.tag.length > 0) {
          this.checkList = data.tag
          this.data = data.tag

          this.checkList.forEach(item => {
            item.checked = false
            if (this.inputList === undefined) {
              this.inputList = []
            }
            this.inputList.forEach(input => {
              if (input.labelId === item.labelId) {
                item.checked = true
              }
            })
          })
        }
      },
      // 点击下面的标签的方法
      clickTag (data) {
        data['checked'] = !data.checked
        if (data['checked']) {
          this.inputList.push(data)
          this.changeTag()
        } else {
          this.removeCheckedListById(data)
        }
      },
      // 点击删除以选中的标签
      deleteTag (data) {
        this.removeCheckedListById(data)
        this.removeCheckListById(this.data, data)
      },
      // 删除Checkedlist的方法(上层)
      removeCheckedListById (data) {
        let reIndex = -1
        this.inputList.forEach((e, index) => {
          if (e.labelId === data.labelId) {
            reIndex = index
          }
        })
        if (reIndex > -1) {
          this.inputList.splice(reIndex, 1)
          this.changeTag()
        }
      },
      /**
       * 删除Checklist的方法
       * @param data 取得当前树的数据
       * @param deleteData 要删除的数据
       */
      removeCheckListById (data, deleteData) {
        for (let item in this.checkList) {
          if (deleteData.labelId === this.checkList[item].labelId) {
            this.checkList[item].checked = false
            return true
          }
        }
      },
      isReset(){
        this.initData()
        this.checkList= []
      }
    },
    beforeCreate() {
      console.log('--------------------------------------------- 子组件1 ---------------------------------------------------------------', this.checkList)
    },
    created() {
      console.log('--------------------------------------------- 子组件2 ---------------------------------------------------------------', this.checkList)
    },
    beforeMount() {
      console.log('--------------------------------------------- 子组件3 ---------------------------------------------------------------', this.checkList)
    },
    updated() {
      console.log('--------------------------------------------- 子组件4 ---------------------------------------------------------------', this.checkList)
      console.info('checkList', this.checkList)
      console.info('inputList', this.inputList)
      console.info('parentDealeList', this.parentDealeList)

    },

  }
</script>
<style lang="scss" scoped>
  .dddd {
    width: 200px;
  }
  .clear {
    clear: both;
  }
  .el-form-item {
    width: 100% !important;
  }
  .tag-div {
    .tag-content {
      overflow: hidden;
      display: inherit;
      align-items: center;
      padding: 5px 0;
      .tag-title {
        position: absolute;
        top: -26px;
        color: #606266 !important;
      }
      .tag-input {
        position: relative;
        float: left;
        width: 93%;
        border: 1px solid #dcdfe6;
        min-height: 32px;
        margin-top: -5px;
        display: flex;
        .close-list {
          cursor: pointer;
          z-index: 999;
          position: absolute;
          right: 6px;
        }
        .checked-tag {
          cursor: pointer;
          float: left;
          background: #1c69d3;
          margin: 2px 0 2px 2px;
          padding: 4px 6px;
          color: #ffffff;
          border: 1px solid #1c69d3;
          border-radius: 3px;
          display: inline;
          line-height: 16px;
          span {
            cursor: pointer;
          }
        }
      }
    }
    .tag-option {
      width: 93%;
      border: 1px solid #ccc;
      background: #fff;
      border-radius: 4px;
      display: -webkit-inline-box;
      display: -ms-inline-flexbox;
      display: inline-flex;
      z-index: 1;
      top: 50px;
      left: 0px;
      height: 150px;
      overflow: hidden;
      overflow-y: scroll;
      .option-tree {
        float: left;
        width: 158px;
        height: 100%;
        background: #eee;
        border-right: 1px solid #ccc;
        .el-tree {
          margin-top: 10px;
          background: #eee;
        }
        .el-tree-node__content:hover {
          background: #eee;
        }
      }
      .option-content {
        float: left;
        width: 640px;
        .each-tag {
          float: left;
          cursor: pointer;
          margin: 10px 0 0 10px;
          padding: 4px 6px;
          color: #1c69d3;
          border: 1px solid #1c69d3;
          border-radius: 3px;
        }
        .each-tag.checked {
          background: #1c69d3;
          color: #fff;
        }
      }
    }
  }
</style>
